export default __webpack_public_path__ + "2d0274624bd4e1e2bb48b111f19462d4.png";